import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { HierarchyService } from '../services/hierarchy.service';
import { SearchResult, SearchResultRow } from '../../models/common/search-result';

@Component({
  selector: '',
  template: '',
})
export class TeamSchemeDetailsSearchHandler extends BaseSearchComponent<HierarchyService> implements OnInit {
  public searchName: string;
  public schemeName: string;
  public evaluationResult: string;
  public startDt: string;
  public endDt: string;

  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    this.searchName = 'SearchTeamSchemeDetails';
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'TeamSchemeDetails',
        link: '/search-team-scheme-details-search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'qualifiedAgent',
        link: '/qualified-subordinates-details/EVALUATION',
      },
      {
        id: 'notQualifiedAgent',
        link: '/unqualified-subordinates-details/EVALUATION',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('TeamSchemeDetails');
    return header;
  }

  qualifiedAgent_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link, this.schemeName, this.startDt, this.endDt]);
  }

  notQualifiedAgent_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link, this.schemeName, this.startDt, this.endDt]);
  }

  /**
   * This is triggered when more option list icon is clicked. This modifies the more option list based on the condition.
   * @param searchRecord current selected row
   */
  onMoreButtonClicked(searchRecord: SearchResultRow) {
    this.schemeName = this.getRecordValue(searchRecord, 'EvaluationResultDO.description');
    this.startDt = this.getRecordValue(searchRecord, 'EvaluationResultDO.startDt');
    this.endDt = this.getRecordValue(searchRecord, 'EvaluationResultDO.endDt');
  }
}
